import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded';
import RemoveRedEyeRounded from '@mui/icons-material/RemoveRedEyeRounded';
import {
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextFieldProps,
} from '@mui/material';
import { useState } from 'react';

export default function InputPassword({
    label,
    name,
    onChange,
    value,
    helperText,
    error,
    size,
    inputRef,
    required,
}: TextFieldProps) {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    return (
        <FormControl fullWidth error={error} required={required}>
            <InputLabel size={size === 'small' ? size : 'medium'}>{label}</InputLabel>
            <OutlinedInput
                name={name}
                label={label}
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton onClick={handleClickShowPassword} edge="end">
                            {showPassword ? <RemoveRedEyeRounded /> : <VisibilityOffRounded />}
                        </IconButton>
                    </InputAdornment>
                }
                onChange={onChange}
                value={value}
                size={size}
                error={error}
                inputRef={inputRef}
            />
            <FormHelperText error={error}>{helperText}</FormHelperText>
        </FormControl>
    );
}
